/**
 * Ключове на предупрежденията от client-service (`ClientWarning` в бекенда).
 * Връщат се от `/clients/check` и `/clients/company-lookup`; преводите са в `common.<ключ>`.
 */
export const ClientWarning = {
    EikInvalid: 'eik_invalid',
    EikNotInCommercialRegister: 'eik_not_in_commercial_register',
    EikUnavailable: 'eik_unavailable',
    NameMismatch: 'companyName_mismatch',
    VatEikDifferent: 'different_eik_vat',
    VatInvalid: 'invalid_vat',
    VatUnavailable: 'vat_unavailable',
    VatRegisteredNotMarked: 'vat_registered_not_marked',
    EgnInvalid: 'eik_egn_invalid',
    CompanyDeleted: 'company_deleted',
    CompanyInLiquidation: 'company_in_liquidation',
    CompanyInsolvent: 'company_insolvent',
} as const;

export type ClientWarningKey = (typeof ClientWarning)[keyof typeof ClientWarning];

/** Откъде е официалното име при разминаване (`NameComparison.source`). */
export const RegistrySource = {
    CommercialRegister: 'COMMERCIAL_REGISTER',
    Bulstat: 'BULSTAT',
} as const;

export type RegistrySourceKey = (typeof RegistrySource)[keyof typeof RegistrySource];
